
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import {
  Delegate,
  Inspect,
  InspectExpress,
} from "@/script/apps/inspect/entity/InspectEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { InspectService } from "@/script/apps/inspect/service/InspectService";
import { ElMessage, ElMessageBox } from "element-plus";
import { DictService } from "@/script/apps/system/service/DictService";
import { Dict } from "@/script/apps/system/entity/SystemEntity";
import bus from "@/script/core/util/Bus";
import { MenuData } from "@/script/core/base/MenuData";
import { DelegateService } from "@/script/apps/inspect/service/DelegateService";

@Options({})
export default class InspectDetail extends BaseDetail {
  private service = new InspectService();

  private insTypes: Dict[] = [];

  private insCcieTypes: Dict[] = [];

  private invoiceTypes: Dict[] = [];

  private sendTypes: Dict[] = [];

  private delegateStates: Dict[] = [];

  private delegateList: Delegate[] = [];

  private expressActiveName = "second";

  private error: string | null = null;

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_ins_inspect",
      "/ins/inspect",
      "/ins/inspect",
      this.service
    );
    data.entity = {
      user: { realName: "" },
      invoice: {},
      sendAddress: {},
      sendExpress: {},
      deliveryAddress: {},
      deliveryExpress: {},
    };
    data.statesName = "ins-order-state";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
  };

  public newEntity() {
    const entity: Inspect = {};
    return entity;
  }

  changeInsType(row: any) {
    row.insTypeName = DictUtil.getItemName(this.insTypes, row.insType);
  }

  changeCertType(row: any) {
    row.certTypeName = DictUtil.getItemName(this.insCcieTypes, row.certType);
  }

  changeFirst(row: any) {
    row.firstName = row.first ? "是" : "否";
  }

  private isEmpty(value: string | null | undefined): boolean {
    if (value === undefined) {
      return true;
    }
    if (value === null) {
      return true;
    }
    value = value.trim();
    if (value.length === 0) {
      return true;
    }
    return false;
  }

  protected initOptions() {
    super.initOptions();

    const dictService = new DictService();
    dictService.loadChildItems("ins-ccie-type", (data: any) => {
      this.insCcieTypes = data;
    });
    dictService.loadChildItems("ins-type", (data: any) => {
      this.insTypes = data;
    });
    dictService.loadChildItems("uc-invoice-type", (data: any) => {
      this.invoiceTypes = data;
    });
    dictService.loadChildItems("ins-send-type", (data: any) => {
      this.sendTypes = data;
    });
    dictService.loadChildItems("ins-delegate-state", (data: any) => {
      this.delegateStates = data;
    });
  }

  public afterLoad() {
    const inspect = this.entity as Inspect;
    inspect.deleteInspectDetails = [];
    this.injectDetailData(
      inspect.inspectDetails!,
      inspect.deleteInspectDetails!
    );
    this.generateRowNo();
    inspect.inspectDetails!.forEach((item) => {
      item.insTypeName = DictUtil.getItemName(this.insTypes, item.insType);
      item.certTypeName = DictUtil.getItemName(
        this.insCcieTypes,
        item.certType
      );
      item.firstName = item.first ? "是" : "否";
    });
    inspect.invoice!.typeName = DictUtil.getItemName(
      this.invoiceTypes,
      inspect.invoice!.type
    );

    const delegateService = new DelegateService();
    delegateService.loadDelegateListByOrder(inspect.id!, (data: any) => {
      this.delegateList = data;
      this.delegateList.forEach((delegate) => {
        delegate.stateName = DictUtil.getItemName(
          this.delegateStates,
          delegate.state!
        );
      });
    });

    if (inspect.sendExpress) {
      inspect.sendExpress.transportModeName = DictUtil.getItemName(
        this.sendTypes,
        inspect.sendExpress?.transportMode
      );
    }
    if (inspect.deliveryExpress) {
      inspect.deliveryExpress.preciseName = inspect.deliveryExpress.precise
        ? "是"
        : "否";
      inspect.deliveryExpress.insuredName = inspect.deliveryExpress.insured
        ? "是"
        : "否";
    }
  }

  private addDelegate() {
    const delegateData = ServiceFactory.build(
      "biz_ins_delegate",
      "/ins/delegate",
      "/ins/delegate",
      this.service
    );

    this.$router.push({
      path: delegateData.detailUrl,
      query: { id: 0, type: "A", cache: "0", inspectId: this.entity.id },
    });

    const menuData: MenuData = {
      name: delegateData.listUrl,
      path: delegateData.detailUrl,
      title: String("委托单"),
      query: { type: "A", cache: "1", inspectId: this.entity.id },
      isClose: true,
    };
    bus.emit("menu-select", menuData);
  }

  private goDelegate(data: any) {
    const delegateData = ServiceFactory.build(
      "biz_ins_delegate",
      "/ins/delegate",
      "/ins/delegate",
      this.service
    );

    this.$router.push({
      path: delegateData.detailUrl,
      query: { id: data.id, type: "M", cache: "0" },
    });

    const menuData: MenuData = {
      name: delegateData.listUrl,
      path: delegateData.detailUrl,
      title: String("委托单"),
      query: { id: data.id, type: "M", cache: "1" },
      isClose: true,
    };
    bus.emit("menu-select", menuData);
  }

  private audit() {
    ElMessageBox.confirm("此操作将[审核订单], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const inspect = this.entity as Inspect;
        this.service.action(
          "/api/ins/inspect/audit",
          inspect,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  private revokeAudit() {
    ElMessageBox.confirm("此操作将[撤销提交], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const inspect = this.entity as Inspect;
        this.service.action(
          "/api/ins/inspect/revoke_audit",
          inspect,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  private receiptGoods() {
    ElMessageBox.confirm("此操作将[签收仪器], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const inspect = this.entity as Inspect;
        this.service.action(
          "/api/ins/inspect/receipt_goods",
          inspect,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  private detection() {
    ElMessageBox.confirm("此操作将[确认提交送检], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const inspect = this.entity as Inspect;
        const errors: string[] = [];
        inspect.inspectDetails!.forEach((item) => {
          if (this.isEmpty(item.factoryNumber)) {
            errors.push(`第 [${item.no}] 行的 [出厂编号] 不能为空！`);
          }
        });
        if (errors.length > 0) {
          this.error = errors.join("");
          ElMessage.error(`验证表格内容失败!具体原因请查看表格上方提示。`);
          return false;
        } else {
          this.error = null;
        }

        this.service.action(
          "/api/ins/inspect/detection",
          inspect,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  private detectionComplete() {
    ElMessageBox.confirm("此操作将[确认检测完成], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const inspect = this.entity as Inspect;
        this.service.action(
          "/api/ins/inspect/detection_complete",
          inspect,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  private receiptMoney() {
    ElMessageBox.confirm("此操作将[确认收款], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const inspect = this.entity as Inspect;
        this.service.action(
          "/api/ins/inspect/receipt_money",
          inspect,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  private returnGoods() {
    ElMessageBox.confirm("此操作将[确认返货], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const inspect = this.entity as Inspect;
        this.service.action(
          "/api/ins/inspect/return_goods",
          inspect,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  download() {
    const inspect = this.entity as Inspect;
    const aTag = document.createElement("a");
    aTag.href = inspect.contractWordUrl!;
    aTag.click();
  }
}
